import api from './client';
export const productsApi = {
  list:          (params?: any) => api.get('/products', { params }),
  create:        (data: any)    => api.post('/products', data),
  categories:    ()             => api.get('/products/categories'),
  createCategory:(data: any)    => api.post('/products/categories', data),
  updateCategory:(id: number, data: any) => api.put(`/products/categories/${id}`, data),
  toggleCategory:(id: number)   => api.post(`/products/categories/${id}/toggle`),
  units:         ()             => api.get('/products/units'),
  createUnit:    (data: any)    => api.post('/products/units', data),
  updateUnit:    (id: number, data: any) => api.put(`/products/units/${id}`, data),
  toggleUnit:    (id: number)   => api.post(`/products/units/${id}/toggle`),
};
